<!--
 * @Author: Scarlett Xiao
 * @Date: 2022-01-04 15:05:32
 * @LastEditors: lishiqiao
 * @LastEditTime: 2022-03-17 11:12:21
-->
<template>
  <!-- 育苗 -->
  <!-- 动保实时有效库存 -->
  <div class="content-wrap">
    <div class="page-list">
      <div class="page-type-switch">
        <div class="type-activite">动保实时有效库存</div>
      </div>
      <!-- 动保实时有效库存 -->
      <StockPage />
    </div>
  </div>
</template>

<script>
import StockPage from "./ym-drug-stock.vue";
export default {
  name: "ym",
  components: {
    StockPage,
  },
};
</script>

<style lang="less" scoped>
</style>